'use strict';

module.exports = {
  ITEM: 'item'
};


/*****************
 ** WEBPACK FOOTER
 ** ./_dustbin-simple/ItemTypes.js
 ** module id = 71
 ** module chunks = 0
 **/